import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';

export const StopListSyncIntervalField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const { t } = useTranslation('form');
	const interval = restaurantForFullInfo?.stopListSyncIntervalMinutes;

	return (
		<FullInfoField
			label="stopListSyncIntervalLabel"
			value={interval ? t('stopListSyncIntervalValue', { value: interval }) : null}
		/>
	);
};
